/**
 * 内容举报客户端。对应服务端 POST /api/rooms/{id}/reports。
 *
 * App Store 审核指南 1.2 要求含用户实时互动（视频/白板/聊天）的应用，
 * 给每个用户「举报不良内容」的入口。屏蔽用户已由成员菜单的 relation
 * （屏蔽文字/语音）解决，这里补的是举报。
 */

import { apiURL } from './endpoint'

/** 举报类别。与服务端 content_reports.category 取值一致。 */
export type ReportCategory = 'chat' | 'video' | 'whiteboard' | 'user' | 'other'

/** 一次举报的输入。 */
export interface ReportInput {
  roomId: number
  token: string
  /** 被举报人账号，举报无主内容（如白板）时可空。 */
  target?: string
  targetNick?: string
  category: ReportCategory
  detail?: string
}

/** 提交一条举报。失败时抛出，调用方负责给用户提示。 */
export async function submitReport(input: ReportInput): Promise<void> {
  const resp = await fetch(apiURL(`/api/rooms/${input.roomId}/reports`), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${input.token}`,
    },
    body: JSON.stringify({
      target: input.target ?? '',
      targetNick: input.targetNick ?? '',
      category: input.category,
      detail: input.detail ?? '',
    }),
  })
  if (!resp.ok) {
    throw new Error(`举报提交失败：${resp.status}`)
  }
}
